import React from "react";
import { Checkbox } from "../ecosystem/";

const ProxySelect = ({ userList, handleCheck }) => {
    return (
        <div className="row proxy-selection-container">
            <div className="col-12">
                <div className="proxy-selected-users-body">
                    {
                        userList.map((user, index) => {
                            return (

                                <Checkbox
                                    checked={user.isChecked}
                                    //handleCheck={() => handleCheck(index)}
                                    onClick={() => handleCheck(user.id)}
                                    key={`proxy-${index}`}
                                    disabled={!user.display.name}
                                    label={`${user.display.name}`}
                                    variant="select"
                                />

                            )
                        }
                        )
                    }
                </div>
            </div>
        </div>
    );
}

export default ProxySelect;